export default __webpack_public_path__ + "static/media/q10.e5aab339.svg";